import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";
import OParticleContainer from "./OParticleContainer";

export default class OParticle extends OParticleContainer {
    constructor(maxSize = 1500, properties = null, batchSize = 16384, autoResize = false) {
        if (!properties)
            properties = {
                vertices: true,
                rotation: true,
                uvs: true,
                tint: true
            };
        super(maxSize, properties, batchSize, autoResize);

        this._oType = OmyConst.OMY_PARTICLE;
        this._emitters = [];

        this.interactChild = false;
        this.isUpdate = true;
    }

    /**     * @public     */
    addEmitter(emitter) {
        if (typeof emitter === "object" && Array.isArray(emitter)) {
            for (let i = 0; i < emitter.length; i++) {
                this._emitters.push(emitter[i]);
            }
        } else {
            this._emitters.push(emitter);
        }
    }

    /**     * @public     */
    play(once = false, onComplete = null, removeOnEnd = false) {
        this._onComplete = onComplete;
        if (!once) {
            for (let i = 0; i < this._emitters.length; i++) {
                this._emitters[i].emit = true;
            }
        } else {
            if (removeOnEnd) {
                for (let i = 0; i < this._emitters.length; i++) {
                    this._emitters[i].playOnceAndDestroy(((onComplete) ? this._onCompleteHandler.bind(this) : null));
                }
            } else {
                for (let i = 0; i < this._emitters.length; i++) {
                    this._emitters[i].playOnce(((onComplete) ? this._onCompleteHandler.bind(this) : null));
                }
            }
        }
        this._countPlay = 0;
    }

    /**     * @private     */
    _onCompleteHandler() {
        if (++this._countPlay >= this._emitters.length) {
            if (this._onComplete)
                this._onComplete();
            this._onComplete = null;
        }
    }

    /**     * @public     */
    stop() {
        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].emit = false;
        }
    }

    emitNow() {
        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].emitNow();
        }
    }

    updateOwnerPos(x, y) {
        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].updateOwnerPos(x, y);
        }
    }

    updateSpawnPos(x, y) {
        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].updateSpawnPos(x, y);
        }
    }

    /**     * @public     */
    kill() {
        if (this._active) {
            this.clear();
            super.kill();
        }

        return this;
    }

    /**     * @public     */
    clear() {
        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].cleanup();
            this._emitters[i].emit = false;
        }
    }

    /**     * @public     */
    revive() {
        if (!this._active) {
            super.revive();
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        if (Omy.game.renderer.plugins && Omy.game.renderer.plugins.sprite && Omy.game.renderer.plugins.sprite.sprites)
            Omy.game.renderer.plugins.sprite.sprites.length = 0;

        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].emit = false;
            this._emitters[i].destroy();
        }
        this._emitters.length = 0;
        this._emitters = null;

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update(delta) {
        for (let i = 0; i < this._emitters.length; i++) {
            this._emitters[i].update(delta / 60.0);
        }
        super.update(delta);
    }

    getEmitter(id = 0) {
        if (!this.numEmitters) return null;
        return this._emitters[id];
    }

    getFrequency(id = -1) {
        if (id < 0) {
            let frequency = 0;
            for (let i = 0; i < this._emitters.length; i++) {
                frequency += this._emitters[i].frequency;
            }
            return frequency / this._emitters.length;
        } else {
            return this._emitters[id].frequency;
        }
    }

    setFrequency(frequency, id = -1) {
        if (id < 0) {
            for (let i = 0; i < this._emitters.length; i++) {
                this._emitters[i].frequency = frequency;
            }
        } else {
            this._emitters[id].frequency = frequency;
        }
    }

    getBehavior(type, id = 0) {
        if (id < 0) {
            OMY.Omy.error("set id of emitter", id);
            return null;
        } else {
            return this._emitters[id].getBehavior(type);
        }
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------
    get numEmitters() {
        return this._emitters.length;
    }
}

OParticle.moveAcceleration = "moveAcceleration";
OParticle.alpha = "alpha";
OParticle.alphaStatic = "alphaStatic";
OParticle.color = "color";
OParticle.colorStatic = "colorStatic";
OParticle.movePath = "movePath";
OParticle.rotation = "rotation";
OParticle.rotationStatic = "rotationStatic";
OParticle.scale = "scale";
OParticle.scaleStatic = "scaleStatic";
OParticle.moveSpeed = "moveSpeed";
OParticle.moveSpeedStatic = "moveSpeedStatic";
